import { customPalette } from "../../theme/theme";

import { createTheme, responsiveFontSizes } from "@mui/material/styles";

const CustomLineItemTheme = createTheme({
  palette: customPalette,
  typography: {
    h4: {
      fontSize: "2rem",
      fontWeight: "bold",
    },
  },
  components: {
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: customPalette.primary.main,
        },
      },
    },
  },
});

export const theme = responsiveFontSizes(CustomLineItemTheme);
